import { createSlice, createSelector, PayloadAction } from "@reduxjs/toolkit";

import { initialState, RootState, UserState } from "./types";

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    signIn: (state) => {
      state.status = UserState.SIGNIN;
      state.authenticated = true;
      state.isOnboarded = true;
    },
    updateNotAuthenticated: (state) => {
      state.status = UserState.NOT_AUTHENTICATED;
      state.authenticated = false;
    },
    logout: (state) => {
      state.authenticated = false;
      state.error = undefined;
      state.status = UserState.SIGNOUT;
      state.fetchedLoginGql = false;
    },
    updateFetchLoginGql: (state) => {
      state.fetchedLoginGql = true;
    },
    updateAuthReady: (state, action: PayloadAction<boolean>) => {
      state.authReady = action.payload;
    },
    updateIsOnboarded: (state) => {
      state.isOnboarded = true;
    },
  },
});
export const {
  logout,
  signIn,
  updateFetchLoginGql,
  updateNotAuthenticated,
  updateAuthReady,
  updateIsOnboarded,
} = authSlice.actions;

/* ----------------- Select Function ----------------- */
const selectAuthState = (state: RootState) => state.auth;
export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state) => state.authenticated,
);
export const selectAuthStatus = createSelector(
  selectAuthState,
  (state) => state.status,
);
export const selectFetchLoginGql = createSelector(
  selectAuthState,
  (state) => state.fetchedLoginGql,
);
export const selectAuthReady = createSelector(
  selectAuthState,
  (state) => state.authReady,
);
export const selectIsOnboarded = createSelector(
  selectAuthState,
  (state) => state.isOnboarded || state.authenticated,
);

export default authSlice.reducer;
